import axios from '@/_services/axios';

export function GetAll(take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`composites/prototype/all?take=${take}&skip=${skip}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetSearch(text, take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`composites/prototype/search?take=${take}&skip=${skip}&searchParam=${text}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Get(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`composites/prototype/${id}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetComposite(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`composites/${id}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}
export function GetByPhaseCode(phaseCode) {
  return new Promise((resolve, reject) => {
    axios
      .get(`composites/phases/${phaseCode}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Save(item) {
  if (item.id === 0) {
    return Create(item);
  }
  return Modify(item);
}

export function UpdateJobCompositeName(compositeId, jobCompositeName) {
  return new Promise((resolve, reject) => {
    axios
      .put(`composites/${compositeId}/composite?jobCompositeName=${jobCompositeName}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

function Create(item) {
  return new Promise((resolve, reject) => {
    axios
      .post('composites/prototype/new', {
        name: item.name,
        materialsParam: item.materialsParam,
        phaseId: item.phase,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

function Modify(item) {
  return new Promise((resolve, reject) => {
    axios
      .put(`composites/prototype/${item.id}`, {
        name: item.name,
        materialPrototypeIds: item.materialsParam,
        phaseId: item.phase.id ? item.phase.id : item.phase,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Remove(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`composites/prototype/${id}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function AddMaterial(id, materialId) {
  return new Promise((resolve, reject) => {
    axios
      .put(`composites/prototype/${id}/material?materialPrototypeId=${materialId}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function RemoveMaterial(id, materialId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`composites/prototype/${id}/material?materialPrototypeId=${materialId}`, { responseType: 'text' })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function DeleteComposite(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`composites/prototype/${id}`, { responseType: 'text' })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function EditSubcontractPrice(jobId, compositePrototypeId, cost) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/composites/${compositePrototypeId}/subcontracting`, {
        cost: cost,
      })
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function GetAllPagingMaterialsFromComposite(compositePrototypeId, take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`composites/${compositePrototypeId}/materialPrototypes?take=${take}&skip=${skip}`)
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function GetSearchMaterial(compositeId, searchParams, take, skip) {
  return new Promise((resolve, reject) => {
    axios
      .get(`composites/${compositeId}/materialPrototypes?take=${take}&skip=${skip}&searchParam=${searchParams}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}
